package com.downdogapp.client.views.menu

import com.downdogapp.*
import com.downdogapp.Size.Companion.px
import com.downdogapp.client.Strings
import com.downdogapp.client.View
import com.downdogapp.client.controllers.menu.SubscriptionViewController
import com.downdogapp.client.resources.Images
import com.downdogapp.client.widget.*
import com.downdogapp.client.widget.StructuredRow.Companion.leftIconRow
import com.downdogapp.client.widget.StructuredRow.Companion.structuredRow

actual class SubscriptionView actual constructor(
  private val controller: SubscriptionViewController
) : TopLevelView(), View {

  override val root =
    controllerView {
      bg = background(true)
      fg = foreground(true) {
        centeredColumnView {
          pageHeader(
            title = Strings.PAYMENT_PLAN,
            onBackClicked = controller::onBackClicked
          )

          div {
            marginBottom = px(14)
            label(controller.subscription.description, 14)
          }

          tableView(::getContents)
        }
      }
    }

  private fun getContents() = TableContents(
    rows = listOfNotNull(
      leftIconRow(
        image = Images.CARD,
        text = controller.subscription.paymentMethodText ?: "",
        subText = controller.subscription.paymentMethodSubtext,
        clickFn = if (controller.subscription.paymentMethodUrl != null)
          controller::paymentMethodClicked
        else
          null
      ),
      if (controller.subscription.canSetAutoRenew)
        structuredRow(DEFAULT_ROW_HEIGHT_PX, allowSeparator = true) {
          leftImage(Images.RENEWAL)
          leftTextContent(text = controller.autoRenewText, subtext = controller.autoRenewSubtext)

          rightToggle(
            getValue = { controller.subscription.willBeChargedAgain },
            onValueChanged = { controller.autoRenewClicked(it) }
          )
        }
      else
        null
    ),
    separator = rightSeparator
  )
}
